import React from "react";
import { FiCheck } from "react-icons/fi";
import fundwalelogo from "../../assets/images/Fundswalle_Logo.png"

const SelfieSuccessPage = ({ setScreen }) => {
  return (
    <section className="fw-screen fw-screen--selfie-success fw-fade">
           <div className="fw-brandmain">
          <img 
            src={fundwalelogo} 
            alt="Fundswalle" 
            className="fw-brand__logo1" 
          />
        </div>
      <div className="fw-selfie-success">
        <span className="fw-selfie-success__icon">
          <FiCheck />
        </span>

        <p>
          Congratulations. Your application has 
          <br />
          been submitted
        </p>
      </div>

      <div className="fw-screen__footer">
        <button
          type="button"
          className="fw-btn fw-btn--dark fw-btn--full"
          // onClick={() => setScreen("/apply-new/profile")}
          onClick={() =>setScreen("/apply-new/sectionLetter")}
        >
          Proceed
        </button>
      </div>
    </section>
  );
};

export default SelfieSuccessPage;